// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"8753ae19","267":"afd88ddb","396":"2286ecb7","404":"ec7c7515","670":"33258b97","755":"54a3eb2c","836":"5ea6d038","927":"df370297"}[chunkId] + ".chunk.js";
};